import React from 'react';
import FieldTypeSelector from '../investments/addInvestment/inputs/Index';
import {
  clearCompanyServiceData,
  updateFieldValue,
} from '../../redux/companyServices/companyServicesSlice';
import {
  commonFieldConfig,
  commonFieldTypes,
} from '../investments/addInvestment/inputs/field.config';
import { AppDispatch, RootState } from '../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import CreateApi from '../../api/genericApis/Create.api';
import Swal from 'sweetalert2';
import { ModuleType } from '../../api/modules.types';

export default function AddService() {
  const dispatch: AppDispatch = useDispatch();
  const serviceData = useSelector((state: RootState) => state.companyServices);

  // Handle input changes for fields
  const handleInputChange = ({
    e,
    field,
    lang,
    isSameValue,
  }: {
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;
    field: string;
    lang: 'ar' | 'en';
    isSameValue: boolean;
  }) => {
    const { value } = e.target;

    dispatch(
      updateFieldValue({
        language: lang,
        field,
        value,
        isSameValue,
      }),
    );
  };

  const headerSectionFieldsEn = [
    {
      label: 'Service Name',
      value: serviceData.en.serviceName,
      field: 'serviceName',
      config: { ...commonFieldConfig['en'][commonFieldTypes.text] },
    },
    {
      label: 'Service Description',
      value: serviceData.en.serviceDescription,
      field: 'serviceDescription',
      config: { ...commonFieldConfig['en'][commonFieldTypes.text] },
    },
  ];

  const headerSectionFieldsAr = [
    {
      label: 'اسم الخدمة',
      value: serviceData.ar.serviceName,
      field: 'serviceName',
      config: { ...commonFieldConfig['ar'][commonFieldTypes.text] },
    },
    {
      label: 'وصف الخدمة',
      value: serviceData.ar.serviceDescription,
      field: 'serviceDescription',
      config: { ...commonFieldConfig['ar'][commonFieldTypes.text] },
    },
  ];

  const imageSection = {
    label: 'Service Image URL',
    value: serviceData.en.serviceImage,
    field: 'serviceImage',
    config: { ...commonFieldConfig['en'][commonFieldTypes.image] },
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Confirm with SweetAlert before submitting
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to submit the service data?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, submit!',
      cancelButtonText: 'No, cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        CreateApi({ moduleType: ModuleType.service, data: serviceData })
          .then((response) => {
            // On success
            Swal.fire({
              title: 'Success!',
              text: 'Service has been successfully added.',
              icon: 'success',
              confirmButtonText: 'Ok',
            });

            // Clear fields after success
            dispatch(clearCompanyServiceData());
          })
          .catch((error) => {
            Swal.fire({
              title: 'Error!',
              text: 'There was an issue submitting the service. Please try again.',
              icon: 'error',
              confirmButtonText: 'Ok',
            });
          });
      }
    });
  };

  return (
    <section className="mb-5 d-flex flex-column">
      <h3 className="mb-3">Add Service</h3>
      <div className="row">
        <div className="col-md-6">
          {headerSectionFieldsEn.map((field, index) => (
            <FieldTypeSelector
              key={index}
              fieldName={field.field}
              label={field.label}
              value={field.value}
              config={field.config}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  field: field.field,
                  lang: 'en',
                  isSameValue: field.config.isSameValue,
                })
              }
            />
          ))}
        </div>
        <div className="col-md-6" dir="rtl">
          {headerSectionFieldsAr.map((field, index) => (
            <FieldTypeSelector
              key={index}
              fieldName={field.field}
              label={field.label}
              value={field.value}
              config={field.config}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  field: field.field,
                  lang: 'ar',
                  isSameValue: field.config.isSameValue,
                })
              }
            />
          ))}
        </div>
      </div>

      <div className="mt-3">
        {imageSection && (
          <FieldTypeSelector
            fieldName={imageSection.field}
            label={imageSection.label}
            value={imageSection.value}
            config={imageSection.config}
            onInputChange={(e) =>
              handleInputChange({
                e,
                field: imageSection.field,
                lang: 'en',
                isSameValue: imageSection.config.isSameValue,
              })
            }
          />
        )}
      </div>

      <button
        onClick={handleSubmit}
        className="btn btn-primary mt-4 align-self-center p-2"
      >
        Submit
      </button>
    </section>
  );
}
